<ng-container [ngSwitch]="AppLayout">
  <app-mainlayout *ngSwitchCase="AppLayouts.User"></app-mainlayout>
  <app-external-layout *ngSwitchCase="AppLayouts.ExternalOutlet"></app-external-layout>
  <app-guestlayout *ngSwitchCase="AppLayouts.Guest"></app-guestlayout>
</ng-container>
